import { action } from 'typesafe-actions';
import * as constants from './constants';
import * as models from '../../models';

export const requestAIToolPublish = (request: models.AIToolPublishRequest) =>
    action(constants.REQUEST_AI_TOOL_PUBLISH, { request });
export const requestAIToolPublishSuccess = () =>
    action(constants.REQUEST_AI_TOOL_PUBLISH_SUCCESS);
export const requestAIToolPublishFailure = (error: string) =>
    action(constants.REQUEST_AI_TOOL_PUBLISH_FAILURE, { error });

export const requestClaimLevelAiTools = (claimId: number) =>
    action(constants.REQUEST_CLAIM_LEVEL_AI_TOOLS, { claimId });
export const receiveClaimLevelAiTools = (toolsDD: models.DropdownListResponse) =>
    action(constants.RECEIVE_CLAIM_LEVEL_AI_TOOLS, { toolsDD });


export const requestExecuteAITool = (claimId: number, toolId: number) =>
    action(constants.REQUEST_EXECUTE_AI_TOOL, { claimId, toolId });
export const requestExecuteAIToolSuccess = (responseData: any) =>
    action(constants.REQUEST_EXECUTE_AI_TOOL_SUCCESS, { responseData });
export const requestExecuteAIToolFailure = (error: string) =>
    action(constants.REQUEST_EXECUTE_AI_TOOL_FAILURE, { error });

export const submitAIToolInput = (input: models.AIToolInput) =>
    action(constants.SUBMIT_AI_TOOL_INPUT, { input });
export const submitAIToolInputSuccess = (responseData: any) =>
    action(constants.SUBMIT_AI_TOOL_INPUT_SUCCESS, { responseData });
export const submitAIToolInputFailure = (error: string) =>
    action(constants.SUBMIT_AI_TOOL_INPUT_FAILURE, { error });
export const resetAIToolExecution = () =>
    action(constants.RESET_AI_TOOL_EXECUTION);

export const requestMatchRuntimeBundle = (toolId: number, files: File[]) =>
    action(constants.REQUEST_MATCH_RUNTIME_BUNDLE, { toolId, files });
export const requestMatchRuntimeBundleSuccess = (result: models.AiRuntimeBundleMatch) =>
    action(constants.REQUEST_MATCH_RUNTIME_BUNDLE_SUCCESS, { result });
export const requestMatchRuntimeBundleFailure = (error: string) =>
    action(constants.REQUEST_MATCH_RUNTIME_BUNDLE_FAILURE, { error });
export const clearRuntimeBundleMatch = () =>
    action(constants.CLEAR_RUNTIME_BUNDLE_MATCH);

export const requestFetchCatalogTools = () =>
    action(constants.REQUEST_FETCH_CATALOG_TOOLS);
export const requestFetchCatalogToolsSuccess = (response: models.AiToolCatlogResponse) =>
    action(constants.REQUEST_FETCH_CATALOG_TOOLS_SUCCESS, { response });
export const requestFetchCatalogToolsFailure = (error: string) =>
    action(constants.REQUEST_FETCH_CATALOG_TOOLS_FAILURE, { error });

export const requestDeleteAiTool = (toolId: number, toolName: string) =>
    action(constants.REQUEST_DELETE_AI_TOOL, { toolId, toolName });

export const requestAiToolConfiguration = (toolId: number) =>
    action(constants.REQUEST_AI_TOOL_CONFIGURATION, { toolId });
export const receiveAiToolConfiguration = (response: models.AiToolConfiguration) =>
    action(constants.RECEIVE_AI_TOOL_CONFIGURATION, { response });

export const updateAiToolConfiguration = (toolId: number, payload: models.AiToolConfiguration) =>
    action(constants.UPDATE_AI_TOOL_CONFIGURATION, { toolId, payload });
export const updateAiToolConfigurationSuccess = (response: models.AiToolConfiguration) =>
    action(constants.UPDATE_AI_TOOL_CONFIGURATION_SUCCESS, { response });
export const updateAiToolConfigurationFailure = (error: string) =>
    action(constants.UPDATE_AI_TOOL_CONFIGURATION_FAILURE, { error });

export const createAiToolConfiguration = (payload: models.CreateAiToolConfiguration) =>
    action(constants.CREATE_AI_TOOL_CONFIGURATION, { payload });
export const createAiToolConfigurationSuccess = (response: models.AiToolConfiguration) =>
    action(constants.CREATE_AI_TOOL_CONFIGURATION_SUCCESS, { response });
export const createAiToolConfigurationFailure = (error: string) =>
    action(constants.CREATE_AI_TOOL_CONFIGURATION_FAILURE, { error });

export const setExecutionComplete = (outputHtml: string, claimId?: number) =>
    action(constants.SET_AI_TOOL_EXECUTION_COMPLETE, { outputHtml, claimId });
export const setExecutionFailed = (errorMessage: string) =>
    action(constants.SET_AI_TOOL_EXECUTION_FAILED, { errorMessage });
